export default function(fetch, siteId, module, fields, id, graphQLTypes) {
  let fieldsQuery = [];
  if (graphQLTypes) {
    fieldsQuery = graphQLTypes.map(
      graphQLType => ` ... on ${graphQLType} { ${fields} } `,
    );
  } else {
    fieldsQuery.push(fields);
  }

  const query = `{
    item: ${module} {
      findById (id: "${id}") {
        ${fieldsQuery.join(' ')}
      }
    }
  }`;

  return fetch(`/${siteId}/graphql`, {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query,
    }),
    credentials: 'include',
  })
    .then(
      resp =>
        // if (resp.status !== 200) throw new Error(resp.statusText);
        resp.status !== 200 ? null : resp.json(),
    )
    .then(json => json.data.item.findById);
}



// WEBPACK FOOTER //
// ./src/data/fetch/getItemById.js